module.exports = __webpack_public_path__ + "static/media/guiaPrimerExamenDM.e9032918.pdf";